'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Modal from 'react-modal';
import ClienteTitle from '../../NuevaSolicitudAdministradora/components/ClienteTitle.jsx';
import Elements from './Elements.jsx';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import HeaderButtons from './HeaderButtons.jsx';
import Footer from './Footer.jsx';
import Table from './Table.jsx';
import ViewEnterpriseInformation from './ViewEnterpriseInformation.jsx';
import DistribucionLimites from '../../DistribucionLimites/components/Container.jsx';
import Breadcrumb from '../../NuevaSolicitudAdministradora/components/MarcaBreadcrumb.jsx'

import { GenericErrorScreen, GenericModal, GenericAlert, GenericModalBreadCrumb } from 'com-gyf-webcore-userinterfacecomponents';

import {
    GET_ENTERPRISE_BY_CUIT,
    GET_ENTERPRISE_BY_CUIT_RESULT,
    GET_DATA_ENTERPRISE,
    SELECT_ENTERPRISE,
    SHOW_ERROR,
    EDIT_TO_NUEVA_EMPRESA,
    GET_DATA_ENTERPRISE_RESULT,
    GUARDAR_SOLICITUD_BORRADOR,
    FUNCTION_CODE_CREATE,
    FUNCTION_CODE_QUERY,
    FUNCTION_CODE_CONFIRMATION,
    FUNCTION_CODE_DISTRIBUTION,
    FUNCTION_CODE_EDIT,
    FUNCTION_CODE_CONFIDENTIA,
    SHOW_SAVE_STATUS,
    SAVE_REQUEST,
    GET_ROUTTING_STATE
} from '../actions/NuevaSolicitudEmpresaActions.js';

let _data;


const AlertaWarning = (props) => {
    if (props.cuentas == undefined || props.tarjetas == undefined)
        return null;

    if (props.cuentas.find(x => x.esNueva == true) != undefined || props.tarjetas.find(x => x.esNueva == true) != undefined) {
        return <div className="alert alert-warning alert-warning-xs">
            <strong>Atención!</strong> Tenga en cuenta que cualquier cambio en las empresas puede generar una perdida de la información de las etapas posteriores de la solicitud.
               </div>
    } else {
        return null;
    }
}

class NuevaSolicitudEmpresa extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStateSolicitudEmpresa();
    }

    render() {

        const { data,tarjetas } = this.props;
        const { redirectToVistaCliente, permisos } = data;

        if (redirectToVistaCliente == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_VISTA_CLIENTE")} push />

        if (this.props.data == undefined)
            return null;

        if (permisos) {

            if (permisos.components.Pantalla.Active == true) {
                let warningPerdidaDatos = null;
                let routtingState = { request: this.props.data.request };

                //Emite un mensaje cuando no se selecciono o dio de alta una empresa para continuar con la carga de la solicitud, o bien cuando no se selecciono o dio de alta una empresa para guardar borrador
                let genericAlert = this.props.data.showError ?
                    <GenericAlert message="Por favor, recuerde que hay que seleccionar o dar de alta una Empresa ya que es parte de la solicitud." type="danger" />
                    : this.props.data.seleccionoEmpresa ?
                        <GenericAlert message="Por favor, recuerde que hay que seleccionar o dar de alta una Empresa para guardar borrador ya que es parte de la solicitud." type="danger" />
                        : null;

                warningPerdidaDatos = (this.props.tarjetas.cuentas.find(x => x.esNueva == true) &&
                    <div className="alert alert-warning alert-warning-xs">
                        <strong>Atención!</strong> Tenga en cuenta que cualquier cambio en las empresas puede generar una perdida de la información de las etapas posteriores de la solicitud.
                                            </div>)


                let distributionModal = null;

                return (
                    <div className="container-fluid">
                       <ClienteTitle
                                    cliente={this.props.tarjetas.clienteResultadoBusqueda}
                                    empresas={this.props.tarjetas.empresas}
                                    novedadesempresas={null}
                                    esmodificacion={false}
                                    />
                        
                        <Breadcrumb
                            menu={this.breadcrumbGenerator(1,tarjetas.tipoEmpresa.Descripcion)}
                        />
                        
                        <HeaderButtons
                            data={this.props.data}
                            permisos={permisos}
                            tarjetas={this.props.tarjetas}
                            openModalDistribucionLimites={this.props.openModalDistribucionLimites}
                        />
                        <br />

                        <AlertaWarning cuentas={this.props.tarjetas.cuentas} tarjetas={this.props.tarjetas.tarjetas} />
                        {genericAlert}

                        {(permisos.components.RadioButtons.Active == true) &&
                            <Table
                                tarjetas={this.props.tarjetas}
                                data={this.props.data}
                                permisos={permisos}
                                seleccionarEmpresa={this.props.seleccionarEmpresa}
                                openModalInformacionEmpresa={this.props.openModalInformacionEmpresa}
                            />}
                        <br />

                        <Footer
                            data={this.props.data}
                            permisos={permisos}
                            routeToNuevaSolicitudCuenta={this.props.routeToNuevaSolicitudCuenta}
                            guardarSolicitudBorrador={this.props.guardarSolicitudBorrador}
                            showError={this.props.showError}
                            seleccionarEmpresa={this.props.seleccionarEmpresa}
                            tarjetas={this.props.tarjetas}
                        />

                        <GenericModal type={"OK_OTHER"} className="modal fade-out"
                            id={"error"}
                            header={"La transacción no puede ser procesada"}
                            body={"Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " + this.props.data.sagaId}
                            onClick={this.props.closeModal} />

                        <GenericModal type={"OK_OTHER"} className="modal fade-out"
                            id={"completada"}
                            body={"La transacción ha sido creada exitosamente"}
                            onClick={this.props.closeModal} />

                        <GenericModal type={"OK_OTHER"} className="modal fade-out"
                            id={"completadaConDependencias"}
                            header={"La transacción esta pendiente a ser procesada"}
                            body={"Disculpe, hay datos en la transacción que dependen de procesos que todavían no fueron finalizados, por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los que dependen esta transacción hayan finalizado correctamente será avisado y la transacción avanzará automáticamente por su circuito normal."}
                            onClick={this.props.closeModal} />


                        {
                            //Modal de límites...
                            <div className="col-md-12">
                                <Modal
                                    isOpen={this.props.data.modalVisibleLimites}
                                    contentLabel="Modal"
                                    className={{ base: 'modal-react-example-css' }}
                                >
                                    <DistribucionLimites
                                        data={this.props.data}
                                        globalState={this.props.globalState}
                                        guardaDatos={false} //<----- indica si la info se guarda en la BBDD...
                                        getDatosFromDB={false} //<----- Se carga con datos de la BBDD y no del store generico al ser true...
                                        currentScope={this.props.currentScope}
                                        functions={permisos}
                                        cerrarModal={this.props.closeModalDistribucionLimites}
                                        actualizarEstadoPantallaInvocadora={this.props.actualizarLimites} //<----- Ejecuta la action que actualiza el estado de la pantalla que lo invoca...
                                    />
                                </Modal>
                            </div>
                        }

                        {
                            //Modal de información de empresa...
                            <div className="col-md-12">
                                <Modal
                                    isOpen={this.props.data.modalVisibleInformacionEmpresa}
                                    contentLabel="Modal"
                                    className={{ base: 'modal-react-example-css' }}
                                >
                                    <ViewEnterpriseInformation
                                        data={this.props.data}
                                        tarjetas={this.props.tarjetas}
                                        globalState={this.props.globalState}
                                        currentScope={this.props.currentScope}
                                        functions={permisos}
                                        cerrarModal={this.props.closeModalInformacionEmpresa}
                                    />
                                </Modal>
                            </div>}

                    </div>
                );
            }
            else {
                if (permisos.components.Pantalla.Active == false) {

                    let values = {
                        message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                        linkMessage: "Volver a mi pagina de inicio"
                    };
                    return <GenericErrorScreen data={values} />;
                }
            }
        } else {
            return null;
        }
    }

    breadcrumbGenerator(idAdm,tipoDeCuenta) {
        let nuevaSolicitudMap = [];

        nuevaSolicitudMap.push({ descripcion: idAdm ==1 ? "VISA": "CABAL", ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: tipoDeCuenta, ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: "Empresa", ruta: "", activo: true, normal: false, anterior: false });
        nuevaSolicitudMap.push({ descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: false });
        nuevaSolicitudMap.push({ descripcion: "Extensiones", ruta: "", activo: false, normal: true, anterior: false });

        return nuevaSolicitudMap;
    }
}

export default NuevaSolicitudEmpresa;
